// extracted by mini-css-extract-plugin
module.exports = {"root":"index__2g2rt7vR"};